// extracted by mini-css-extract-plugin
export default {"dashboard":"Header_dashboard__TxcxT","header":"Header_header__5L-SG","welcomeHeading":"Header_welcomeHeading__-6C76"};